module.exports = __webpack_public_path__ + "Tinebase/js/ace-jsoniq-FAT.js";